import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllGraduationCards,
  onCreateGraduationCard,
  onDeleteGraduationCard,
  onGetGraduationCard,
  onUpdateGraduationCard,
  onUpdateGraduationCardStatus,
  onGetGraduationCardByGraduatedId,
  onGetGraduationCardByUserId,
  onUpdateBatchGraduationCardStatus,
  onUpdateBatchGraduationDeliveryType,
} from '../../../app/modules/graduation-system/components/graduation-cards/core/_requests'
import {
  onGetGraduates,
  onGetCardStatuses,
  onGetDeliveryTypes,
  onGetSubDepartmentsByDepartmentId,
  onGetDegrees,
  onGetProgramTypesByDegreeId,
  onGetDepartmentsByFacultyId,
  onGetFaculties,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import { onGetAddressesByGraduateId } from '../../../app/modules/profile/addresses/core/_requests'
interface GraduationCardState {
  graduationCards: any
  graduationCard: any
  graduates: any
  cardStatuses: any
  userCards: any
  deliveryTypes: any
  graduateAddresses: any
  faculties: any
  departments: any
  degrees: any
  programTypes: any
  subDepartments: any
  isLoading: boolean
  isAddressLoading : boolean
}
const initialState = {
  graduationCards: [],
  graduationCard: null,
  graduates: [],
  cardStatuses: [],
  userCards: [],
  deliveryTypes: [],
  graduateAddresses: [],
  faculties: [],
  departments: [],
  degrees: [],
  programTypes: [],
  subDepartments: [],
  isLoading: true,
  isAddressLoading: false
} as GraduationCardState

export const fetchGraduates = createAsyncThunk('graduationCard/fetchGraduates', async () => {
  const data: any = await onGetGraduates()
  return data.data.result
})

export const fetchCardStatuses = createAsyncThunk('graduationCard/fetchCardStatuses', async () => {
  const data: any = await onGetCardStatuses()
  return data.data.result
})

export const fetchDeliveryTypes = createAsyncThunk(
  'graduationCard/fetchDeliveryTypes',
  async () => {
    const data: any = await onGetDeliveryTypes()
    return data.data.result
  }
)

export const fetchGraduateAddresses = createAsyncThunk(
  'graduationCard/fetchGraduateAddresses',
  async (param: any) => {
    const data: any = await onGetAddressesByGraduateId(param)
    return data.data.result
  }
)

export const fetchGraduationCards = createAsyncThunk(
  'graduationCard/fetchGraduationCards',
  async (param: any) => {
    const data: any = await onGetPagedAllGraduationCards(param)
    return data.data.result
  }
)

export const fetchGraduationCardsByGraduatedId = createAsyncThunk(
  'graduationCard/fetchGraduationCardsByGraduatedId',
  async (param: any) => {
    const data: any = await onGetGraduationCardByGraduatedId(param)
    return data.data.result
  }
)

export const fetchGraduationCardsByUserId = createAsyncThunk(
  'graduationCard/fetchGraduationCardsByUserId',
  async (param: any) => {
    const data: any = await onGetGraduationCardByUserId(param)
    return data.data.result
  }
)

export const fetchGraduationCard = createAsyncThunk(
  'graduationCard/fetchGraduationCard',
  async (param: any) => {
    const data: any = await onGetGraduationCard(param)
    return data.data.result
  }
)

export const updateGraduationCard = createAsyncThunk(
  'graduationCard/updateGraduationCard',
  async (param: any) => {
    const data: any = await onUpdateGraduationCard(param)
    return data.data
  }
)

export const updateGraduationCardStatus = createAsyncThunk(
  'graduationCard/updateGraduationCardStatus',
  async (param: any) => {
    const data: any = await onUpdateGraduationCardStatus(param)
    return data.data
  }
)
export const updateBatchGraduationCardStatus = createAsyncThunk(
  'graduationCard/updateBatchGraduationCardStatus',
  async (param: any) => {
    const data: any = await onUpdateBatchGraduationCardStatus(param)
    return data.data
  }
)
export const updateBatchGraduationDeliveryType = createAsyncThunk(
  'graduationCard/updateBatchGraduationDeliveryType',
  async (param: any) => {
    const data: any = await onUpdateBatchGraduationDeliveryType(param)
    return data.data
  }
)

export const createGraduationCard = createAsyncThunk(
  'graduationCard/createGraduationCard',
  async (param: any) => {
    const data: any = await onCreateGraduationCard(param)
    return data.data
  }
)

export const deleteGraduationCard = createAsyncThunk(
  'graduationCard/deleteGraduationCard',
  async (param: any) => {
    const data: any = await onDeleteGraduationCard(param)
    return data.data
  }
)



export const fetchFaculties = createAsyncThunk('sendEmail/fetchFaculties', async () => {
  const data: any = await onGetFaculties()
  return data.data.result
})

export const fetchDepartments = createAsyncThunk(
  'sendEmail/fetchDepartments',
  async (param: any) => {
    const data: any = await onGetDepartmentsByFacultyId(param)
    return data.data.result
  }
)

export const fetchSubDepartments = createAsyncThunk(
  'sendEmail/fetchSubDepartments',
  async (param: any) => {
    const data: any = await onGetSubDepartmentsByDepartmentId(param)
    return data.data.result
  }
)

export const fetchDegrees = createAsyncThunk('sendEmail/fetchDegrees', async () => {
  const data: any = await onGetDegrees()
  return data.data.result
})

export const fetchProgramTypes = createAsyncThunk(
  'sendEmail/fetchProgramTypes',
  async (param: any) => {
    const data: any = await onGetProgramTypesByDegreeId(param)
    return data.data.result
  }
)

const graduationCardSlice = createSlice({
  name: 'graduationCard',
  initialState,
  reducers: {
    clearGraduationCards: (state) => {
      state.graduationCards = []
      state.userCards = []
    },
    clearGraduationCard: (state) => {
      state.graduationCard = null
    },   
    clearGraduateAddress: (state) => {
      state.graduateAddresses = []
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
    activateAddressLoading: (state) => {
      state.isAddressLoading = true
    },
    clearAllFilters: (state) => {
      //state.faculties = []
      state.departments = []
      state.subDepartments = []
      state.programTypes = []
      state.degrees = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGraduationCards.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduationCards.fulfilled, (state: any, action) => {
      state.graduationCards = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduationCards.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchGraduationCardsByGraduatedId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduationCardsByGraduatedId.fulfilled, (state: any, action) => {
      state.graduationCards = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduationCardsByGraduatedId.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchGraduationCardsByUserId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduationCardsByUserId.fulfilled, (state: any, action) => {
      state.userCards = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduationCardsByUserId.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchGraduationCard.fulfilled, (state: any, action) => {
      state.graduationCard = action.payload
    })
    builder.addCase(fetchGraduates.fulfilled, (state: any, action) => {
      state.graduates = action.payload.items
    })
    builder.addCase(fetchCardStatuses.fulfilled, (state: any, action) => {
      state.cardStatuses = action.payload.items
    })
    builder.addCase(fetchDeliveryTypes.fulfilled, (state: any, action) => {
      state.deliveryTypes = action.payload.items
    })   
    builder.addCase(fetchGraduateAddresses.pending, (state: any, action) => {
      state.isAddressLoading = true
    })
    builder.addCase(fetchGraduateAddresses.fulfilled, (state: any, action) => {
      state.graduateAddresses = action.payload.items
      state.isAddressLoading = false
    })
    builder.addCase(fetchGraduateAddresses.rejected, (state: any, action) => {
      state.isAddressLoading = false
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload.items
    })
    builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
      state.departments = action.payload.items
    })
    builder.addCase(fetchSubDepartments.fulfilled, (state: any, action) => {
      state.subDepartments = action.payload.items
    })
    builder.addCase(fetchDegrees.fulfilled, (state: any, action) => {
      state.degrees = action.payload.items
    })
    builder.addCase(fetchProgramTypes.fulfilled, (state: any, action) => {
      state.programTypes = action.payload.items
    })
  },
})

export const {clearGraduationCards, clearGraduationCard, clearGraduateAddress, activateLoading, activateAddressLoading, clearAllFilters} =
  graduationCardSlice.actions

export default graduationCardSlice.reducer
